module.exports = "/site/themes/rkt/_/buckleys/node_modules/@fortawesome/fontawesome-pro/webfonts/fa-regular-400.woff2";


//////////////////
// WEBPACK FOOTER
// ../~/@fortawesome/fontawesome-pro/webfonts/fa-regular-400.woff2
// module id = 73
// module chunks = 3